import type { RangyRange } from '../types/rangy';
import rangy from './rangy';

export default (range: Range): RangyRange => {
  // Is already one?
  if ('toHtml' in range) {
    // claude eslint: runtime check confirms range is RangyRange (has toHtml method)
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
    return range as RangyRange;
  }

  const rangyRange = rangy.createRange();
  rangyRange.setStartAndEnd(
    range.startContainer,
    range.startOffset,
    range.endContainer,
    range.endOffset,
  );
  return rangyRange;
};
